import { Deserializable } from '../../../protocols/deserializable';
import { HighGuideProductSignal } from './high-guide-product-signal';
import { ProductSignalUser } from './product-signal-user';

/**
 * Every teammate's product signals for the company, excluding the requesting user's own - those come back from
 * `get-highguide-product-signals` instead. Favorite-only signals are filtered out server side.
 *
 * `signalsByVariantId` must be rehydrated here and nowhere else. Neither the websocket download nor the OPFS cache
 * read runs a JSON reviver, so without this `onDeserialize` the property comes back as a prototype-less plain object
 * statically typed as a `Map` - every `.get()` would throw at runtime and TypeScript would not catch it.
 * `typedArrayMapOf` tolerates both the plain-object and the real-`Map` form, so it is safe on either path.
 *
 * On the way out to the HighGuide iframe, `StringifyUtils.highGuideAppReplacer` flattens the `Map` back into a
 * plain object, which is exactly what the receiving `typedArrayMapOf` expects.
 */
export class HighGuideCompanySignals implements Deserializable {
  public users: ProductSignalUser[];
  public signalsByVariantId: Map<string, HighGuideProductSignal[]>;

  onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    this.users = Deserialize?.arrayOf(ProductSignalUser, this.users) ?? [];
    this.signalsByVariantId =
      Deserialize?.typedArrayMapOf(HighGuideProductSignal, this.signalsByVariantId) ??
      new Map<string, HighGuideProductSignal[]>();
  }
}
